<template>
  <div class="ov d-flex flex-column align-items-center" :class="cls">
    <slot></slot>
    <div class="ov__index" :class="status ? '_done': ''">{{index}}</div>
  </div>
</template>

<script>
export default {
  name: "CheckPointOverviewBox",
  props: {
    index: {
      type: [Number, String]
    },
    status: {
      type: Boolean
    },
    cls: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.ov {
  padding: 25px;
  border-radius: 5px;
  overflow: hidden;
  background-color: rgba($color: #303C54, $alpha: 0.1);
  position: relative;
  transition: ease .4s all;
  margin-bottom: 30px;
  user-select: none;
  min-width: 330px;

  &.active {
    background-color: #fff;
    &:hover {
      box-shadow: 10px 19px 24px rgba(0, 0, 0, 0.03);
    }
  }


  img {
    width: 175px;
    height: 175px;
    margin-bottom: 15px;
  }

  &__index {
    bottom: 0;
    left: 0;
    position: absolute;
    width: 48px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-radius: 5px;
    font-size: 24px;
    font-weight: bold;
    background-color: rgba(224, 42, 88, .1);
    color: #E02A58;
    &._done {
      color: #118FA6;
      background-color: rgba(17, 143, 166, .1);
    }
  }
  
  b {
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 5px;
  }

  p {
    margin-bottom: 0;
  }
}
</style>